(function () {
  'use strict';

  var REDIRECT_GUARD_KEY = 'birtz_geo_lang_redirect_count';
  var LOCALE_FIX_KEY = 'birtz_geo_locale_fix_attempted';
  var MAX_REDIRECTS_PER_SESSION = 2;
  var LOCALE_SUBDOMAINS = ['es', 'de'];

  var configNode = document.getElementById('birtz-geo-language-config');
  if (!configNode) return;

  var config = {};
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var MAIN_DOMAIN = resolveMainDomain(config);
  var currentHost = normalizeHost(config.currentHost || window.location.hostname);

  if (window.BIRTZ_SHOP) {
    window.BIRTZ_SHOP.mainDomain = MAIN_DOMAIN;
  }

  if (shouldSkipRedirect()) {
    return;
  }

  var redirectCount = parseInt(sessionStorage.getItem(REDIRECT_GUARD_KEY) || '0', 10);
  if (redirectCount >= MAX_REDIRECTS_PER_SESSION) {
    return;
  }

  var redirectStarted = false;

  fetchDetectedCountry()
    .then(function (countryCode) {
      if (!countryCode || redirectStarted) {
        return;
      }

      applyGeoLanguage(countryCode);
    })
    .catch(function () {
      /* Geolocation lookup failed — keep current storefront */
    });

  function resolveMainDomain(configData) {
    var fromConfig = (configData && configData.mainDomain) || '';
    var fromGlobal = window.BIRTZ_SHOP && window.BIRTZ_SHOP.mainDomain;

    if (fromConfig) {
      return normalizeHost(fromConfig);
    }

    if (fromGlobal) {
      return normalizeHost(fromGlobal);
    }

    return stripLocaleSubdomain(normalizeHost(window.location.hostname));
  }

  function stripLocaleSubdomain(host) {
    for (var i = 0; i < LOCALE_SUBDOMAINS.length; i++) {
      var prefix = LOCALE_SUBDOMAINS[i] + '.';
      if (host.indexOf(prefix) === 0) {
        return host.slice(prefix.length);
      }
    }

    return host;
  }

  function shouldSkipRedirect() {
    if (window.Shopify && window.Shopify.designMode) {
      return true;
    }

    if (!MAIN_DOMAIN || MAIN_DOMAIN.indexOf('.myshopify.com') !== -1) {
      return true;
    }

    if (currentHost.indexOf('.myshopify.com') !== -1) {
      return true;
    }

    if (window.location.pathname.indexOf('/checkout') === 0) {
      return true;
    }

    if (window.location.search.indexOf('oseid=') !== -1) {
      return true;
    }

    return false;
  }

  function normalizeHost(hostname) {
    return (hostname || '').toLowerCase().replace(/^www\./, '');
  }

  function countryToHost(countryCode) {
    var country = (countryCode || '').toUpperCase();

    if (country === 'ES') {
      return 'es.' + MAIN_DOMAIN;
    }

    if (country === 'DE') {
      return 'de.' + MAIN_DOMAIN;
    }

    return MAIN_DOMAIN;
  }

  function countryToLocale(countryCode) {
    var country = (countryCode || '').toUpperCase();

    if (country === 'ES') {
      return 'es';
    }

    if (country === 'DE') {
      return 'de';
    }

    return 'en';
  }

  function stripLocalePrefix(pathname) {
    var path = pathname || '/';
    var match = path.match(/^\/(es|de|en)(?=\/|$)/i);

    if (!match) {
      return path;
    }

    var rest = path.slice(match[0].length);
    return rest || '/';
  }

  function buildRedirectUrl(targetHost) {
    return (
      window.location.protocol +
      '//' +
      targetHost +
      stripLocalePrefix(window.location.pathname) +
      window.location.search +
      window.location.hash
    );
  }

  function applyGeoLanguage(countryCode) {
    var targetHost = countryToHost(countryCode);
    var expectedLocale = countryToLocale(countryCode);

    if (currentHost !== targetHost) {
      redirectStarted = true;
      var nextCount = redirectCount + 1;
      sessionStorage.setItem(REDIRECT_GUARD_KEY, String(nextCount));
      window.location.replace(buildRedirectUrl(targetHost));
      return;
    }

    ensureLocale(expectedLocale, countryCode);
  }

  function ensureLocale(expectedLocale, countryCode) {
    if (sessionStorage.getItem(LOCALE_FIX_KEY) === '1') {
      return;
    }

    var currentLocale = (config.currentLocale || '').toLowerCase();
    var localeBase = currentLocale.split('-')[0];

    if (localeBase === expectedLocale) {
      return;
    }

    if (!document.body) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          submitLocalizationForm(expectedLocale, countryCode);
        },
        { once: true }
      );
      return;
    }

    submitLocalizationForm(expectedLocale, countryCode);
  }

  function submitLocalizationForm(languageCode, countryCode) {
    sessionStorage.setItem(LOCALE_FIX_KEY, '1');

    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      config.rootUrl ||
      '/';

    if (root.slice(-1) !== '/') {
      root += '/';
    }

    var formId = 'birtz-geo-localization-form';
    var existingForm = document.getElementById(formId);

    if (existingForm) {
      existingForm.remove();
    }

    var form = document.createElement('form');
    form.id = formId;
    form.method = 'POST';
    form.action = root + 'localization';
    form.hidden = true;

    var methodInput = document.createElement('input');
    methodInput.name = '_method';
    methodInput.value = 'PUT';
    form.appendChild(methodInput);

    var countryInput = document.createElement('input');
    countryInput.name = 'country_code';
    countryInput.value = countryCode;
    form.appendChild(countryInput);

    var languageInput = document.createElement('input');
    languageInput.name = 'language_code';
    languageInput.value = languageCode;
    form.appendChild(languageInput);

    var localeInput = document.createElement('input');
    localeInput.name = 'locale_code';
    localeInput.value = languageCode;
    form.appendChild(localeInput);

    var returnToInput = document.createElement('input');
    returnToInput.name = 'return_to';
    returnToInput.value = window.location.pathname + window.location.search + window.location.hash;
    form.appendChild(returnToInput);

    document.body.appendChild(form);
    form.submit();
  }

  function fetchDetectedCountry() {
    var root = config.rootUrl || '/';

    if (root.slice(-1) !== '/') {
      root += '/';
    }

    var endpoint = root + 'browsing_context_suggestions.json?country[enabled]=true';

    return fetch(endpoint, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Geolocation request failed');
        }

        return response.json();
      })
      .then(function (payload) {
        if (payload && payload.detected_values && payload.detected_values.country) {
          return (payload.detected_values.country.handle || '').toUpperCase();
        }

        return '';
      });
  }
})();
